// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__EicVc","active":"navbar_active__fCu0i","profile":"navbar_profile__8g82a"};